import { render, staticRenderFns } from "./Partes.vue?vue&type=template&id=6305dec7&scoped=true"
import script from "./Partes.vue?vue&type=script&lang=js"
export * from "./Partes.vue?vue&type=script&lang=js"
import style0 from "./Partes.vue?vue&type=style&index=0&id=6305dec7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6305dec7",
  null
  
)

export default component.exports